package com.example.mystybag.sharedmodels.project.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginUserResponseModel(
    var userId                          : Long      = 0L,
    var token                           : String    = "",
    var email                           : String    = "",
    var firstName                       : String    = "",
    var lastName                        : String    = "",
    var userImgUrl                      : String    = "",
    var dialCode                        : String    = "",
    var phoneNumber                     : String    = "",
    var cityId                          : Long      = 0L,
    var numberOfReservations            : Int       = 0,
    var savedAmount                     : Double    = 0.0,
    var reservationCompletedPushEnabled : Boolean   = true,
    var reservationCompletedEmailEnabled: Boolean   = false,
    var discountsAndNewsPushEnabled     : Boolean   = true,
    var discountsAndNewsEmailEnabled    : Boolean   = false,
    var hasPendingDeleteAccountRequest  : Boolean   = false
): BaseResponseModel()
